import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileTypeJpg = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	strokeLinejoin: "round",
	strokeLinecap: "round",
	stroke: "currentColor",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 15h3v4.5a1.5 1.5 0 0 1 -3 0" })
	]
});
const ForwardRef = forwardRef(SvgFileTypeJpg);
export default ForwardRef;
